/*
 * webpack.import.js - seo-admin
 * Copyright (c) CHECK24 Vergleichsportal Reise GmbH 2023.
 *
 * @author     Mark Kotsarev <mark.kotsarev@check24.de>
 * @modified   11.05.23, 11:01
 */

window.fireOnVisible(document.querySelectorAll('.wt-Content'), async() => {
    await import('./assets/css/content.scss');
});
